const Management = () =>
  import(/* webpackChunkName: "management" */ '@/views/management/Management.vue');
const NewCandidate = () =>
  import(/* webpackChunkName: "management" */ '@/views/management/NewCandidate.vue');

const router = [
  {
    path: '/',
    component: Management,
    meta: {
      // fullWidth: true,
    },
  },
  {
    path: 'new-candidate',
    component: NewCandidate,
    meta: {
      permissions: ['canCreate'],
    },
  },
];

export default router;
